import React from "react";

import Dialog from "@material-ui/core/Dialog";
import {
  Box,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@material-ui/core";
import { useAppStyles } from "../../../../App.style";
import { useStyles } from "./style";
import { IconButton } from "../../../../common/components/core";
import { closeBlackIcon, handRaisedImg } from "../../../../constants/images";
import { AppButton } from "../../../../common/components/AppButton";

export const ReplaceCardSuccessDialog = (props) => {
  const { handleClose, onClickViewVirtualCard } = props;

  const appClasses = useAppStyles();
  const classes = useStyles();
  return (
    <Dialog
      open={true}
      onClose={() => handleClose()}
      aria-labelledby="form-dialog-title"
      maxWidth={"sm"}
      fullWidth
      PaperProps={{ className: appClasses.paperCard }}
    >
      <DialogTitle id="form-dialog-title">
        <div className={appClasses.dialogTitle}>
          <IconButton
            className={appClasses.dialogCloseBtn}
            onClick={() => handleClose()}
          >
            <img src={closeBlackIcon} />
          </IconButton>
        </div>
      </DialogTitle>
      <Divider></Divider>

      <DialogContent className={appClasses.dialogContent1}>
        <div className={classes.imgWrapper}>
          <img src={handRaisedImg} height={250} width={250} />
        </div>
        <div className={classes.imgWrapper}>
          <Typography variant="h6" className={appClasses.text3}>
            New card ordered
          </Typography>
          <Box mt={1} />
          <Typography variant="span" className={appClasses.text1}>
            Your old card is now deactivated. Your new one should arrive within 10 business days.


          </Typography>
          <Box mt={1} />
          <Typography variant="span" className={appClasses.text1}>
            You can continue to receive payouts, and make transfers from within the app.
          </Typography>
          <Box mt={1} />
          <Typography variant="span" className={appClasses.text1}>
            You can also make online purchases using your virtual card.
          </Typography>
        </div>
        <Box mt={3} />
        <AppButton
          contained
          onClick={() => { onClickViewVirtualCard() }}
          className={`${appClasses.primaryBtn} ${appClasses.width100p}`}
          primary
        >
          View Virtual Card
        </AppButton>
        <Box mt={2} />
      </DialogContent>
    </Dialog>
  );
};
